
import { Component, Prop, Vue } from 'vue-property-decorator';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';
import LabelWithValue from '../../../core/components/Indicators/LabelWithValue.vue';
import Button from '../../../core/components/Generics/Button.vue';
import SinisterAppraisersList from '../sinisters/SinisterAppraisersList.vue'
import { Sinister } from '../../../../features/typescript/sinisters/sinisterInfo';

@Component({
  components: {
    SimpleMap,
    LabelWithValue,
    Button,
    SinisterAppraisersList
  },
})
export default class SinisterInspection extends Vue {
  @Prop({ default: () => [] }) sinister!: Sinister[];
  inspectionDate: string = '2020-03-02';
  inspectionState: string = 'Recibido';
  

}
